import { render, staticRenderFns } from "./IndexUserCharts2.vue?vue&type=template&id=f496b334&scoped=true&"
import script from "./IndexUserCharts2.vue?vue&type=script&lang=js&"
export * from "./IndexUserCharts2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f496b334",
  null
  
)

export default component.exports